// @ts-nocheck
import clsx from 'clsx'
import { FC } from 'react'
import { Row } from 'react-table'
import { Product } from '../../../core/_models'
import { useNavigate } from 'react-router-dom'
import { useListView } from '../../../core/ListViewProvider'
import useAuthorization from '../../../../../hooks/useAuthorization'
import { TooltipWrapper } from '../../../../../components/Tooltip'

type Props = {
    row: Row<Product>
}

const CustomRow: FC<Props> = ({ row }) => {

    const id = String(row.original.id) as string;
    const name = String(row.original.name) as string;

    const navigate = useNavigate()
    const isAuthorizedToUpdate = useAuthorization("admin.payment_options");
    const handleToEdit = () => navigate(`/admin/payment-options/${id}/edit`)

    const { setItemForDelete } = useListView()

    return <tr {...row.getRowProps()}>
        {row.cells.map((cell) => {
            return (
                <td
                    {...cell.getCellProps()}
                    className={clsx({ 'text-end min-w-100px': cell.column.id === 'actions' })}
                >
                    {cell.render('Cell')}
                </td>
            )
        })}
        <td className="text-center min-w-120px">
            {isAuthorizedToUpdate &&
                <TooltipWrapper
                    tooltipText={'Editar'}
                    tooltipPlacement={'top'}
                >
                    <button disabled={id < 4} className="btn btn-link btn-color-muted btn-active-color-danger" onClick={() => handleToEdit()}>
                        <i className="ki-duotone ki-pencil me-5 fs-1">
                            <span className="path1"></span>
                            <span className="path2"></span>
                        </i>
                    </button>
                </TooltipWrapper>
            }
            {/* <button disabled className="btn btn-danger" onClick={() => { }}>Excluir</button> */}
        </td>
    </tr >
}

export { CustomRow }
